import { MDSText } from '@midwest/web/base';
import * as Drawer from '@radix-ui/react-dialog';
import styled from 'styled-components';

export const DrawerOverlay = styled(Drawer.Overlay)`
  background-color: rgba(54, 54, 54, 0.5);
  position: fixed;
  inset: 0;
  @media (prefers-reduced-motion: no-preference) {
    animation: overlayShow 250ms ease-in;
  }
  @keyframes overlayShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const DrawerContainer = styled(Drawer.Content)<{
  size?: 'xl' | 'md';
  $zIndex: number;
}>`
  height: calc(100dvh - ${(p) => p.theme.spacing.md});
  pointer-events: all;
  border: ${(p) => p.theme.border.widthDefault} solid
    ${(p) => p.theme.midwestColors.borderDefault};
  border-radius: 8px 8px 0px 0px;
  background: ${(p) => p.theme.midwestColors.backgroundPrimary};
  box-shadow: ${(p) => p.theme.spacing.md};
  position: fixed;
  display: flex;
  flex-direction: column;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  z-index: ${(p) => p.$zIndex};
  @media (prefers-reduced-motion: no-preference) {
    &[data-state='open'] {
      animation: mobileContentShow 250ms ease-in;
    }
    &[data-state='closed'] {
      animation: mobileContentHide 250ms ease-out;
    }
  }

  ${(p) => p.theme.breakpoints.tablet} {
    max-height: 100vh;
    height: 100%;
    border-radius: 8px 0px 0px 8px;
    left: auto;
    width: ${(props) => (props.size === 'xl' ? 600 : 480)}px;
    @media (prefers-reduced-motion: no-preference) {
      &[data-state='open'] {
        animation: contentShowDrawer 250ms ease-in;
      }
      &[data-state='closed'] {
        animation: contentHideDrawer 250ms ease-out;
      }
    }
  }

  ${(p) => p.theme.breakpoints.desktop} {
    width: ${(props) => (props.size === 'xl' ? 810 : 480)}px;
  }

  @keyframes contentShowDrawer {
    from {
      opacity: 0;
      transform: translate(100%, 0);
    }
    to {
      opacity: 1;
    }
  }

  @keyframes contentHideDrawer {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: translate(100%, 0);
    }
  }

  @keyframes mobileContentShow {
    from {
      opacity: 0;
      transform: translate(0, 100%);
    }
    to {
      opacity: 1;
    }
  }

  @keyframes mobileContentHide {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: translate(0, 100%);
    }
  }
`;

export const HeadingText = styled(MDSText.TitleMd)`
  margin: 0;
  color: ${(p) => p.theme.midwestColors.textPrimary};
`;

export const DrawerHeader = styled(Drawer.Title)`
  display: flex;
  justify-content: space-between;
  margin: 0;
`;

export const DrawerHeaderLayout = styled.div`
  align-items: center;
  padding: ${(p) => p.theme.spacing.xlg};
  display: flex;
  flex-direction: row;
  border-bottom: ${(p) => p.theme.border.widthDefault} solid
    ${(p) => p.theme.midwestColors.borderDefault};
  flex: 0 0;
`;

export const DrawerContent = styled.div`
  padding: ${(p) => p.theme.spacing.xlg};
  margin: 0;
  overflow-y: auto;
  flex: 1;
`;

export const DrawerFooter = styled.div`
  padding: ${(p) => p.theme.spacing.md};
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.xsm};
  border-top: ${(p) => p.theme.border.widthDefault} solid
    ${(p) => p.theme.midwestColors.borderDefault};
  ${(p) => p.theme.breakpoints.tablet} {
    flex-direction: row;
    justify-content: flex-start;
  }
  & button {
    width: 100%;
    ${(p) => p.theme.breakpoints.tablet} {
      width: auto;
    }
  }
`;

export const DrawerFooterLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: 0 0;
`;

export const DrawerCloseIconWrapper = styled(Drawer.Close)`
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  margin-left: auto;
`;
